

exports.__esModule = true;
exports.metricCounter = undefined;

var _beaverLogger = require('@krakenjs/beaver-logger');

var logger = new _beaverLogger.Logger({
    url: location.host.indexOf('localhost') >= 0 ? 'https://www.msmaster.qa.paypal.com/xoplatform/logger/api/logger' : '/xoplatform/logger/api/logger',
    prefix: 'hermesnodeweb',
    metricNamespacePrefix: 'pp.xo.hermes',
    flushInterval: 10000
});

var metricCounter = exports.metricCounter = function metricCounter(event) {
    var dimensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    logger.metricCounter({ namespace: 'custom', event: event, dimensions: dimensions });
};

_beaverLogger.Logger;


//////////////////
// WEBPACK FOOTER
// ./js/lib/metricLogger.js
// module id = ./js/lib/metricLogger.js
// module chunks = 0